import * as React from "react";
import { useRef } from "react";
import { IconButton, Popover, Tooltip, Box } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useBoolState } from "@dvrt/react-tools";
import { useCurrentMeeting } from "../contexts/currentMeeting";
import Html from "../../Html";
import { HasPermission, SimpleSection } from "../../tools";
import EditIcon from "@mui/icons-material/Edit";
import { Link } from "react-router-dom";
import { defineMessage, FormattedMessage } from "react-intl";

const MeetingInfoPanel = () => {
    const currentMeeting = useCurrentMeeting();

    return (
        <Box sx={{ padding: "1em", position: "relative" }}>
            <Box sx={{ fontSize: "1.4em", textAlign: "center", marginBottom: "0.5em" }}>
                {currentMeeting.meeting.summary}
            </Box>
            <HasPermission name="edit_meeting">
                <Box sx={{ position: "absolute", top: 3, right: 3 }}>
                    <Tooltip
                        title={
                            <FormattedMessage
                                id="meetingPage.room.editMeeting"
                                defaultMessage="Open the edit meeting page in a new window or tab"
                            />
                        }
                        arrow
                        placement="top"
                    >
                        <IconButton
                            component={Link}
                            to={`/meeting/edit/${currentMeeting.meeting.id}`}
                            size="small"
                            target="_blank"
                        >
                            <EditIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </Box>
            </HasPermission>
            <SimpleSection title={defineMessage({ id: "meetings.description", defaultMessage: "Description" })}>
                <Html html={currentMeeting.meeting.description} />
            </SimpleSection>
        </Box>
    );
};

export default () => {
    const [isShow, show, hide] = useBoolState();
    const buttonRef = useRef<HTMLButtonElement>(null);

    return (
        <React.Fragment>
            <IconButton style={{ marginLeft: "0.2em" }} ref={buttonRef} onClick={show} size="large">
                <FontAwesomeIcon icon="info-circle" size="xs" />
            </IconButton>
            <Popover
                open={isShow}
                onClose={hide}
                anchorEl={buttonRef.current}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                <MeetingInfoPanel />
            </Popover>
        </React.Fragment>
    );
};
